import { render, staticRenderFns } from "./health-record.vue?vue&type=template&id=53d39d0a&scoped=true&"
import script from "./health-record.vue?vue&type=script&lang=js&"
export * from "./health-record.vue?vue&type=script&lang=js&"
import style0 from "./health-record.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./health-record.vue?vue&type=style&index=1&id=53d39d0a&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "53d39d0a",
  null
  
)

export default component.exports